export { extractIdFromBase64Hash } from './extractIdFromBase64Hash'
